import { FUZZY_PINYIN_LEVEL, type FuzzyPinyinLevel } from "./constants.js";
import { pinyinSetsIntersect } from "./pinyin.js";
import type { IdiomDict } from "./types-dict.js";
import type { RejectReason } from "./protocol.js";

const HAN = /^[\u4e00-\u9fff]{4}$/;

export function validateFormat(word: string): boolean {
  return HAN.test(word);
}

export type ValidateOk = { ok: true };
export type ValidateFail = { ok: false; reason: RejectReason };
export type ValidateResult = ValidateOk | ValidateFail;

export function validateChain(opts: {
  word: string;
  lastWord: string;
  lastPinyins: readonly string[];
  usedWords: ReadonlySet<string>;
  dict: IdiomDict;
  fuzzyLevel?: FuzzyPinyinLevel;
}): ValidateResult {
  const { word, lastPinyins, usedWords, dict } = opts;
  const fuzzyLevel = opts.fuzzyLevel ?? FUZZY_PINYIN_LEVEL;

  if (!validateFormat(word)) return { ok: false, reason: "INVALID_FORMAT" };

  const entry = dict[word];
  if (!entry) return { ok: false, reason: "NOT_IN_DICT" };

  if (usedWords.has(word)) return { ok: false, reason: "ALREADY_USED" };

  if (!pinyinSetsIntersect(entry.firstPinyins, lastPinyins, fuzzyLevel)) {
    return { ok: false, reason: "WRONG_PINYIN" };
  }

  return { ok: true };
}

export function localPrecheck(word: string): boolean {
  return validateFormat(word);
}
